export const data = {
  issue: {
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/79f64852764c-tooliconpliers.jpg',
    },
    title: 'Tell us more about the problem.<br>This will be used in your letter',
  },
  orderNumber: {
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/9d24a0a39698-tooliconnumber3.jpg',
    },
    title: 'What is your order number?',
  },
  purchasePrice: {
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/35a9c0e3cc29-tooliconmoney.jpg',
    },
    title: 'How much did you pay for it?',
  },
  whichRetailer: {
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
    },
    title: 'Which retailer did you buy the item from?',
    placeholderText: 'e.g. Currys, Amazon',
  },
}
